module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA60lEQVQ4T6XSIU/DQBjG8f/a4pioABQhQSwYvkM/wNLkvSYEJA4SFBY7i1oyiYRB07yp7TfAEyweX3tHZun1bstO3/u73Ps8E/Y8kz3nGQAicgc8WGuv2rb9jj0wAKqqurDWvgEH2yDeLxhjzpxza2AaQ0Z3ICLHwDtwFEKCSyzLcpqm6QdwOoZEUyiKIsvzfIPMfEgU2KQgIq/AjaoO7kcBEXkBbvu+P+y6rv8faxAwxqycc/fAiar++joRSuEZeMyy7Lyu65+xQnkBEVkAT8Clqn6F2uir8hxYJkly3TTN585Vjg3stMRtsD/0UFkRm4IAwAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/d.png
// module id = VZSZ
// module chunks = 16